module.exports = __webpack_public_path__ + "img/plan1_ok.8aeebeed.png";